import { desktopTruncateStyle } from '~/styles/utilities.css';

type Props = {
  nextNumber: string;
};

export const NumberingSeriesNextNumberCell = ({ nextNumber }: Props) => {
  return <div className={desktopTruncateStyle}>{nextNumber}</div>;
};
